export default __webpack_public_path__ + "static/dummy-blog-3-c8973eb38420c48ad08fc89753eca190.png";